const pageInIframe = window.location !== window.parent.location;

export default pageInIframe;
